import { render, staticRenderFns } from "./PersonalDashboard.vue?vue&type=template&id=7281aea8&scoped=true&"
import script from "./PersonalDashboard.vue?vue&type=script&lang=js&"
export * from "./PersonalDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDashboard.vue?vue&type=style&index=0&id=7281aea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7281aea8",
  null
  
)

export default component.exports